import {
  AccountTreeOutlined,
  GroupOutlined,
  PersonOutlined,
} from "@mui/icons-material";
import { Box, SvgIconTypeMap, Typography } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { useLocalization } from "../hooks/useLocalization";
import { AssignedVia } from "./ManageAccessDialog";

interface AssignedViaCellProps {
  assignedVia: AssignedVia[];
}

export const ASSIGNED_VIA_DIRECT = "Direct";

type AssignedViaDisplay = {
  Icon: OverridableComponent<SvgIconTypeMap> | null;
  text: string;
};

const getAssignedViaDisplay = (
  assignedVia: AssignedVia[],
  t: (key: string) => string,
): AssignedViaDisplay => {
  if (assignedVia.length === 0 || !assignedVia[0]) {
    return { Icon: null, text: "-" };
  }

  if (assignedVia.length > 1) {
    return {
      Icon: AccountTreeOutlined,
      text: t("components.assignedViaCell.multiple"),
    };
  }

  const source = assignedVia[0].source;

  if (source === ASSIGNED_VIA_DIRECT) {
    return {
      Icon: PersonOutlined,
      text: t("components.assignedViaCell.directAccess"),
    };
  }

  return { Icon: GroupOutlined, text: source };
};

export const AssignedViaCell: React.FC<AssignedViaCellProps> = ({
  assignedVia,
}) => {
  const { t } = useLocalization();
  const { Icon, text } = getAssignedViaDisplay(assignedVia, t);

  return (
    <Box
      alignItems="center"
      display="flex"
      gap={1}
      justifyContent={{ xs: "flex-end", md: "flex-start" }}
    >
      {Icon && <Icon sx={{ fontSize: 16 }} />}
      <Typography
        sx={{
          fontSize: { xs: 14, md: 12 },
          fontWeight: { xs: 500, md: 400 },
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};
